import { getWalletBookWallet } from './getWalletBookWallet.js';
import { logger } from './logger.js';
import { renderTemplate } from './renderTemplate.js';

const getWalletIconUrl = (walletBook, walletName) => {
    try {
        const walletData = getWalletBookWallet(walletBook, walletName);
        if (walletData?.brand?.spriteId) {
            return renderTemplate('iconicUrl', walletData.brand.spriteId);
        }
        if (walletData?.brand?.imageId) {
            return renderTemplate('walletConnectUrl', walletData.brand.imageId);
        }
    }
    catch (err) {
        logger.error(err);
    }
    return '';
};

export { getWalletIconUrl };
